import React from 'react';
import Skeleton from '@mui/material/Skeleton';

import scss from './DataBlock.module.scss';

function InfoItem({ value, label, isLoading }) {
  return (
    <li className={scss.infoItem}>
      <span className={scss.infoLabel}>{label}:</span>
      {isLoading ? (
        <Skeleton variant='text' sx={{ fontSize: '12px', bgcolor: '--table-body-text' }} width={40} />
      ) : (
        <span className={scss.infoText}>{value || '-/-'}</span>
      )}
    </li>
  );
}

export default InfoItem;
